import _ from 'lodash';
import appHelpers from 'app/app-helpers';
import actionTypes from '../actions/action-types';

const initialState = {
  items: {},
  interval: 3000,
  draft: false,
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BANNERS_REQUEST:
    case actionTypes.FETCH_BANNERS_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
        items: {},
      };
    case actionTypes.FETCH_BANNERS_SUCCESS: {
      const items = _.groupBy(action.result.entries, 'locale');
      action.locales.forEach((locale) => {
        items[locale.code] = items[locale.code]
          ? items[locale.code].reduce((bannerArr, entry) => {
            const fields = appHelpers.getFieldsFromEntry(entry)[entry.locale];
            return bannerArr.concat({ ...fields, id: entry.id });
          }, [])
          : [];
      });
      const { interval } = action.result.properties;
      const draft = action.result.versionType === 'DRAFT';

      return {
        ...state,
        isLoading: action.isLoading,
        items: { ...items },
        interval,
        draft,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/banners.reducer.js